export default (
	endpoint,
	{
		posts,
		postsCount,
	}
) => ({
	posts: posts,
	postsCount: postsCount,
	page: 2,
	order: "desc",
	orderBy: "date",

	isLoading: false,

	loadMore() {
		this.isLoading = true;
		fetch(`${endpoint}?page=${this.page}&orderBy=${this.orderBy}&order=${this.order}`, {
			method: 'GET',
		}).then((resp) => {
			if (resp.ok) {
				resp.json().then((json) => {
					this.posts = this.posts.concat(json.data.items);
					this.postsCount = json.data.pagination.total;
					this.page++;
					this.isLoading = false;
				});
			} else {
				this.isLoading = false;
			}
		});
	},

	orderByChanged() {
		this.posts = [];
		this.page = 1;
		this.loadMore();
	},

	init() {
		this.$watch('orderBy', orderBy => {this.orderByChanged()});
	}
});
